import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { Amenagement } from '../models/options/situationProfessionnelles/amenagement'

const resource = 'Amenagements'

export default class AmenagmentsResource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<Amenagement>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
